document.addEventListener('DOMContentLoaded', function() {
    // TAB FUNCTIONALITY
    const tabButtons = document.querySelectorAll('.faq-tab');
    const tabContainers = document.querySelectorAll('.faq-tab-container');
    
    // Track which accordions have been initialized
    const initializedTabs = new Set();
    
    function showTab(tabId) {
        // Hide all tab containers
        tabContainers.forEach(container => {
            container.style.display = 'none';
            container.classList.remove('faq-tab--active');
        });
       
        // Show selected tab container
        const activeContainer = document.querySelector(`.faq-tab-container[data-tab="${tabId}"]`);
        if (activeContainer) {
            activeContainer.style.display = 'flex';
            activeContainer.classList.add('faq-tab--active');
            
            // Initialize accordions if not already done
            if (!initializedTabs.has(tabId)) {
                initAccordions(activeContainer);
                initializedTabs.add(tabId);
            }
        }
        
        // Update tab buttons
        tabButtons.forEach(button => {
            button.classList.remove('faq-tab--active');
            if (button.getAttribute('data-tab') === tabId) {
                button.classList.add('faq-tab--active');
            }
        });
    }
    
    // Add click events to tab buttons
    tabButtons.forEach(button => {
        button.addEventListener('click', function() {
            const tabId = this.getAttribute('data-tab');
            showTab(tabId);
        });
    });
    
    // ACCORDION FUNCTIONALITY
    function initAccordions(container) {
        const questions = container.querySelectorAll('.faq-question');
        
        questions.forEach(question => {
            // Remove any existing click handler first
            question.removeEventListener('click', handleAccordionClick);
            question.addEventListener('click', handleAccordionClick);
        });
    }
    
    // Separate accordion click handler
    function handleAccordionClick() {
        const item = this.parentElement;
        const isActive = item.classList.contains('active');
        const container = item.closest('.faq-tab-container');
        
        // Close all other items in this container
        container.querySelectorAll('[class^="faq-container-"]').forEach(otherItem => {
            if (otherItem !== item) {
                otherItem.classList.remove('active');
                const otherAnswer = otherItem.querySelector('.faq-anwser');
                otherAnswer.style.display = 'none';
                const otherIcon = otherItem.querySelector('.faq-question-icon');
                otherIcon.querySelector('rect:first-child').style.display = 'block';
            }
        });
        
        // Toggle current item
        if (isActive) {
            item.classList.remove('active');
            const answer = this.nextElementSibling;
            answer.style.display = 'none';
            const icon = this.querySelector('.faq-question-icon');
            icon.querySelector('rect:first-child').style.display = 'block';
        } else {
            item.classList.add('active');
            const answer = this.nextElementSibling;
            answer.style.display = 'block';
            const icon = this.querySelector('.faq-question-icon');
            icon.querySelector('rect:first-child').style.display = 'none';
        }
    }
    
    // Initialize first tab
    const activeTab = document.querySelector('.faq-tab.faq-tab--active') || tabButtons[0];
    if (activeTab) {
        const tabId = activeTab.getAttribute('data-tab');
        showTab(tabId);
    }
});